import { CrmFormFragment } from '@touch4it/ng-swp/form/fragments';
import { Observable, of } from 'rxjs';
import { crmGetFormInput } from '@touch4it/ng-swp/form/inputs';
import { crmEmailValidator, crmFormEmailValidator, crmFormRequiredValidator } from '@touch4it/ng-swp/form';

export const getDetailFieldsFactory = () => {
  return (): Observable<CrmFormFragment[]> =>
    of([
      crmGetFormInput({
        name: 'firstName',
        config: {
          label: 'generic.firstName',
          validators: [crmFormRequiredValidator()],
        },
        options: {
          placeholder: 'placeholder.enterFirstName',
        },
      }),
      crmGetFormInput({
        name: 'lastName',
        config: {
          label: 'generic.lastName',
          validators: [crmFormRequiredValidator()],
        },
        options: {
          placeholder: 'placeholder.enterLastName',
        },
      }),
      crmGetFormInput({
        name: 'email',
        config: {
          label: 'generic.email',
          validators: [crmFormRequiredValidator(), crmFormEmailValidator({ validator: crmEmailValidator() })],
        },
        options: {
          placeholder: 'placeholder.enterEmail',
        },
      }),
    ]);
};
